import React, { useState, useEffect } from 'react';
import { ref, onValue, remove, update } from 'firebase/database';
import { database } from '../../firebase/config';
import { FaStar, FaTrash, FaCheck } from 'react-icons/fa';
import './Admin.css';

const GestionAvis = () => {
  const [avis, setAvis] = useState([]);
  const [filter, setFilter] = useState('tous');

  useEffect(() => {
    const avisRef = ref(database, 'avis');
    onValue(avisRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const avisList = Object.entries(data).map(([id, avis]) => ({
          id,
          ...avis
        }));
        setAvis(avisList.sort((a, b) => new Date(b.date) - new Date(a.date)));
      }
    });
  }, []);

  const handleDelete = async (id) => {
    if (window.confirm('Supprimer cet avis ?')) {
      try {
        const avisRef = ref(database, `avis/${id}`);
        await remove(avisRef);
      } catch (error) {
        console.error('Erreur lors de la suppression', error);
      }
    }
  };

  const handleValidate = async (id) => {
    try {
      const avisRef = ref(database, `avis/${id}`);
      await update(avisRef, { valide: true });
    } catch (error) {
      console.error('Erreur lors de la validation', error);
    }
  };

  const filteredAvis = avis.filter(a => {
    if (filter === 'valides') return a.valide === true;
    if (filter === 'en-attente') return !a.valide;
    return true;
  });

  const moyenne = avis.reduce((acc, curr) => acc + (curr.note || 0), 0) / avis.length || 0;

  return (
    <div className="gestion-container">
      <h2>Gestion des avis clients</h2>
      
      <div className="avis-stats">
        <div className="stat-box">
          <h3>Total avis</h3>
          <p>{avis.length}</p>
        </div>
        <div className="stat-box">
          <h3>Note moyenne</h3>
          <p>{moyenne.toFixed(1)}/5</p>
        </div>
        <div className="stat-box">
          <h3>En attente</h3>
          <p>{avis.filter(a => !a.valide).length}</p>
        </div>
      </div>

      <div className="filters">
        <button 
          className={`filter-btn ${filter === 'tous' ? 'active' : ''}`}
          onClick={() => setFilter('tous')}
        >
          Tous
        </button>
        <button 
          className={`filter-btn ${filter === 'en-attente' ? 'active' : ''}`}
          onClick={() => setFilter('en-attente')}
        >
          En attente
        </button>
        <button 
          className={`filter-btn ${filter === 'valides' ? 'active' : ''}`}
          onClick={() => setFilter('valides')}
        >
          Validés
        </button>
      </div>

      <div className="avis-list">
        {filteredAvis.map(avi => (
          <div key={avi.id} className={`avis-item ${avi.valide ? 'valide' : 'en-attente'}`}>
            <div className="avis-header">
              <div className="avis-user">
                <strong>Client</strong>
                <div className="avis-stars">
                  {[...Array(5)].map((_, i) => (
                    <FaStar key={i} color={i < avi.note ? '#ffc107' : '#e4e5e9'} />
                  ))}
                </div>
              </div>
              <div className="avis-date">
                {new Date(avi.date).toLocaleDateString('fr-FR')}
              </div>
            </div>
            
            <p className="avis-text">{avi.commentaire}</p>
            
            <div className="avis-footer">
              <span className={`status-badge ${avi.valide ? 'valide' : 'en-attente'}`}>
                {avi.valide ? 'Validé' : 'En attente'}
              </span>
              
              <div className="avis-actions">
                {!avi.valide && (
                  <button 
                    onClick={() => handleValidate(avi.id)}
                    className="btn-validate"
                  >
                    <FaCheck /> Valider
                  </button>
                )}
                <button 
                  onClick={() => handleDelete(avi.id)}
                  className="btn-delete"
                >
                  <FaTrash /> Supprimer
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default GestionAvis;